import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MaintenanceRoutineSupplyImportModel } from 'src/app/models/imports/maintenance-routine-supply-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { MaintenanceRoutineSupplyModel } from 'src/app/models/maintenance/maintenance-routine-supply.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceRoutineSupplyService {

  constructor(private _httpClient: HttpClient) { }

  createAsync(maintenanceRoutineSupply: MaintenanceRoutineSupplyModel): Observable<MaintenanceRoutineSupplyModel> {
    return this._httpClient.post<MaintenanceRoutineSupplyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.CreateAsync}`,
      maintenanceRoutineSupply);
  }

  createMultipleSuppliesAsync(listDetails: Array<MaintenanceRoutineSupplyModel>, maintenancRoutineId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.CreateMultipleSuppliesAsync}/${maintenancRoutineId}`,
      listDetails);
  }

  deleteElement(maintenancRoutineSupplyId: number): Observable<MaintenanceRoutineSupplyModel> {
    return this._httpClient.delete<MaintenanceRoutineSupplyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.DeleteAsync}/${maintenancRoutineSupplyId}`);
  }

  deleteSomeSupplies(elementIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.DeleteSomeDetailsAsync}`,
      elementIds);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllSupplies(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.GetAllSuppliesAsync}`,
      filters, { params: params }
    );
  }

  getMaintenanceRoutineSuppliesWithPaginationAsync(maintenanceRoutineId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('maintenanceRoutineId', maintenanceRoutineId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.GetMaintenanceRoutineSuppliesWithPaginationAsync}`,
      { params: params }
    );
  }

  getAllSuppliesForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.GetAllSuppliesForSelectAsync}`);
  }

  getMaintenanceRoutineSupplyById(id: number): Observable<MaintenanceRoutineSupplyModel> {
    return this._httpClient.get<MaintenanceRoutineSupplyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.GetByIdAsync}/${id}`);
  }

  getColumnsAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.GetColumnsAsync}`);
  }

  getColumnsForArticlesAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.GetColumnsForArticlesAsync}`);
  }

  getMaintenanceRoutineSupplyByKeysAsync(maintenanceRoutineId: number, articleId: number): Observable<MaintenanceRoutineSupplyModel> {
    return this._httpClient.get<MaintenanceRoutineSupplyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.GetMaintenanceRoutineSupplyByKeysAsync}/${maintenanceRoutineId}/${articleId}`);
  }

  getQuantitySupplies(maintenancRoutineId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.GetQuantitySuppliesAsync}/${maintenancRoutineId}`);
  }

  importMaintenanceRoutineSupply(maintenanceRoutineSupplyImport: Array<MaintenanceRoutineSupplyImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.ImportMaintenanceRoutineSupply}`, maintenanceRoutineSupplyImport);
  }

  updateAsync(maintenanceRoutineSupplyModel: MaintenanceRoutineSupplyModel): Observable<MaintenanceRoutineSupplyModel> {
    return this._httpClient.put<MaintenanceRoutineSupplyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceRoutineSupply.UpdateAsync}`,
      maintenanceRoutineSupplyModel);
  }
}
